import { OrderedMap, Map } from 'immutable';
import { types as buildsTypes, records as buildsRecords } from '@saucelabs/sl-module-builds';
import { records as jobRecords } from '@saucelabs/sl-module-jobs';

import { types } from '.';

const initialState = new Map({
  build: new buildsRecords.BuildRecord(),
  jobs: new OrderedMap(),
  loading: true,
  pollerId: 0,
  truncated: true,
});


const buildsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case buildsTypes.BUILD_GET.SUCCESS:
      return state
        .set('build', new buildsRecords.BuildRecord({
          ...payload,
          status: payload.status || 'new',
        }))
        .set('loading', false);
    case buildsTypes.BUILD_JOBS_GET.SUCCESS: {
      let jobs = state.get('jobs');
      payload.jobs.forEach((job) => {
        jobs = jobs.update(
          job.id,
          [job.id, new jobRecords.JobRecord(job)],
          (jobRecord) => new jobRecords.JobRecord({ ...jobRecord, ...job }),
        );
      });
      return state
        .set('jobs', jobs)
        .set('truncated', payload.truncated);
    }
    case buildsTypes.BUILD_UPDATED_JOBS_GET.SUCCESS: {
      let jobs = state.get('jobs');
      payload.jobs.forEach((job) => {
        jobs = jobs.update(
          job.id,
          [job.id, new jobRecords.JobRecord(job)],
          (jobRecord) => new jobRecords.JobRecord({ ...jobRecord, ...job }),
        );
      });
      return state.set('jobs', jobs);
    }
    case types.CLEANUP:
      return initialState;
    case types.SAVE_BUILDS_TIMEOUT:
      return state.set('pollerId', payload);
    case types.UNSUBSCRIBE_BUILDS: {
      clearTimeout(state.get('pollerId'));
      return state.set('pollerId', initialState.get('pollerId'));
    }
    default:
      return state;
  }
};

export default buildsReducer;
